import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';
import './cardInfo.scss';

export const CardInfoModule = angular
    .module('app.components.cardInfo', [
        CreditCardUtilitiesServiceModule
    ]).component('cardInfo', {
        bindings: {
            brand: '<',
            lastFour: '<',
            expiration: '<'
        },
        template: `
            <div class="card-info" layout="row" layout-align="start center">
                <div class="card-info__image">
                    <span class="credit-card-img" ng-class="$ctrl.ccClass"></span>
                </div>
                <div class="card-info__text" layout="column">
                    <div layout-xs="column" layout-gt-xs="row">
                        <span class="card-info__title">
                            {{$ctrl.brand}} {{'UPDATEPAYMENTCARD.ENDINGIN' | translate}} {{$ctrl.lastFour}}
                        </span>
                        <span class="card-info__expiration">
                            <span>{{'UPDATEPAYMENTCARD.EXP' | translate}} </span>
                            <span>{{$ctrl.expiration.month}}/{{$ctrl.expiration.year}}</span>
                        </span>
                    </div>
                    <span class="card-info__desc">This is your default payment method for all admin purchases.</span>
                </div>
            </div>
        `,
        controller: class CardInfoCtrl {
            constructor(creditCardUtilities) {
                'ngInject';

                angular.extend(this, {
                    creditCardUtilities
                });
            }

            $onInit() {
                this.updateCcClass();
            }

            $onChanges(changesObj) {
                if (changesObj.brand && changesObj.brand.currentValue !== changesObj.brand.previousValue) {
                    this.updateCcClass();
                }
            }

            updateCcClass() {
                this.ccClass = this.creditCardUtilities.getCssClass(this.brand);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/creditCards/cardInfo/cardInfo.js